import { Observable } from "rxjs";
import { Status } from "../../models/status";

export abstract class StatusApi {
  public abstract getPredefinedStatuses(): Observable<Status[]>;
}
